import { useGetCurrentUserSuspenseQuery } from "#lib/useGetCurrentUserSuspenseQuery.ts";
import { useMemo } from "react";

export const useSubscriptionTier = () => {
    const { data: { subscriptionTier } } = useGetCurrentUserSuspenseQuery();

    const isPremium = useMemo(() => subscriptionTier === "Premium", [subscriptionTier]);
    const isFreemium = useMemo(() => !isPremium, [isPremium]);

    return { isPremium, isFreemium };
};
